/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckboxOn16 = (props: Props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm-2.239 3.894-5.513 5.52-2.01-2.012L3 8.642l3.248 3.252L13 5.134z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCheckboxOn16 as CheckboxOn16 };
